import { EventStartCall } from '@revenuewell/front-end-bundle';
import { PhoneWidget, usePhoneWidget } from '@revenuewell/widget-phone';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { FC, useEffect } from 'react';

export interface Phone2LoaderProps {
  onPatientProfileClick: (phoneNumber: string) => void;
}

export const Phone2Loader: FC<Phone2LoaderProps> = (props) => {
  const { onPatientProfileClick } = props;
  const { listen } = useEventBus();
  const { phoneActions } = usePhoneWidget();
  const { selectedLocation, locations } = useLocations();

  useEffect(
    () =>
      listen('startCall', (event) => {
        const { data } = event as EventStartCall;
        phoneActions.call(data.phoneNumber);
      }),
    [phoneActions.call, selectedLocation, locations]
  );

  return (
    <PhoneWidget
      events={{
        onPatientProfileClick: onPatientProfileClick
      }}
    />
  );
};
